import { atom } from "jotai";

export const completeSessionErrorAtom = atom<unknown | undefined>(undefined);
export const completeSessionIsLoadingAtom = atom(false);
export const completeSessionIsSuccessAtom = atom(false);
